<template>
  <router-link :to="go_to()" class="server link">
    <tr class="server_item">
      <td :data-label="translate('server.name')">
        {{ server.name }}
      </td>
      <td :data-label="translate('server.name_short')">
        {{ server.name_short }}
      </td>
      <td :data-label="translate('server.client_name')">
        {{ server.client_name }}
      </td>
      <td :data-label="translate('server.group')">
        {{ get_group_server(server.server_group_id) }}
      </td>
      <td :data-label="translate('server.place')">
        {{ server.place }}
      </td>
      <td :data-label="translate('server.hoster')">
        {{ server.hoster }}
      </td>
      <td data-label="IP">
        {{ server.ip }}
      </td>
      <td :data-label="translate('server.instances')">
        {{ server.instance_count }}
      </td>
      <td :data-label="translate('server.devices')" @click.stop.prevent="">
        <router-link :to="'/device_list?&universal_search=server_id:' + server.id">
          {{ server.device_count }}
        </router-link>
      </td>
    </tr>
  </router-link>
</template>
<script>


export default {
  name: 'ServerItem',
  props: ["server", "groups_servers"],
  data () {
    return {
    }
  },
  computed:{
  },
  methods: {
    go_to() {
      return { path: '/server/' + this.server.id }
    },

    get_group_server(group_id){
      for (let group of this.groups_servers){
        if (group.id === group_id){
          return group.name
        }
      }
    },

  }
}
</script>

<style lang="scss" scoped>
.server{
  .server_item{
    cursor: pointer;
    margin-top: -1px;
    &:hover{
      background-color: #eee;
    }
  }
  tr {
    font-size: 12px;
    background-color: white;
    &:hover {
      background-color: #f1f1f1;
    }
  }
}
</style>
